/* TDS v22 (26 Oct 2026): product page — move Ingredients / Feeding guide / Dosage / Directions sections out of
   Description into their own "Ingredients & dosage" accordion, open by default; Description then starts closed. */
(function(){
  var RE=/ingredient|feeding|dosage|direction|how to use|serving/i;
  function run(){
    var accs=document.querySelectorAll('.tds-pdp-acc');
    for(var a=0;a<accs.length;a++){
      var acc=accs[a];
      if(acc.getAttribute('data-v22'))continue;
      acc.setAttribute('data-v22','1');
      var desc=acc.querySelector('details.tds-pdp-desc');
      var body=desc&&desc.querySelector('.p');
      if(!body)continue;
      var kids=Array.prototype.slice.call(body.children),use=[],inUse=false;
      for(var i=0;i<kids.length;i++){
        if(kids[i].tagName==='H2')inUse=RE.test(kids[i].textContent);
        if(inUse)use.push(kids[i]);
      }
      if(!use.length)continue;
      var d=document.createElement('details');
      d.className='tds-pdp-desc tds-pdp-use';
      d.open=true;
      var s=document.createElement('summary');
      s.textContent='Ingredients & dosage';
      var box=document.createElement('div');
      box.className='p';
      d.appendChild(s);d.appendChild(box);
      for(var j=0;j<use.length;j++){
        var el=use[j];
        if(el.tagName==='H2'){
          var h=document.createElement('h3');
          h.innerHTML=el.innerHTML;
          if(el.id)h.id=el.id;
          box.appendChild(h);
          el.parentNode.removeChild(el);
        }else{box.appendChild(el)}
      }
      desc.open=false;
      desc.parentNode.insertBefore(d,desc.nextSibling);
      if(!body.children.length&&!body.textContent.trim())desc.parentNode.removeChild(desc);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
